import { render, staticRenderFns } from "./TDark.vue?vue&type=template&id=ad024290&scoped=true&"
import script from "./TDark.vue?vue&type=script&lang=js&"
export * from "./TDark.vue?vue&type=script&lang=js&"
import style0 from "./TDark.vue?vue&type=style&index=0&id=ad024290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad024290",
  null
  
)

export default component.exports